import { ChangeEvent, forwardRef, useEffect } from 'react';
interface VideoVolumeBarProps {
  type: string;
  id?: string;
  min?: number | string;
  max?: number | string;
  step?: number | string;
  value?: number;
  onChange?: (
    event: ChangeEvent<HTMLInputElement>,
  ) => void | { target: { value?: any; style?: any; min: number; max: number } };
  className?: string;
  style?: React.CSSProperties;
  // Add any other props you might be using
}
const VideoVolumeBar = forwardRef<HTMLInputElement, VideoVolumeBarProps>((props, ref) => {
  useEffect(() => {
    const sliders = document.querySelectorAll<HTMLInputElement>('.e-range-volume');

    // Define update function outside of the loop for proper cleanup
    const update = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const val =
        ((Number(target.value) - Number(target.min)) / (Number(target.max) - Number(target.min))) *
        100;
      target.style.setProperty('--range-progress', `${val}%`);
    };

    sliders.forEach((slider) => {
      slider.addEventListener('input', update);

      // Initialize the progress bar
      const initialValue = slider.value;
      const initialMin = slider.min;
      const initialMax = slider.max;
      const val =
        ((Number(initialValue) - Number(initialMin)) / (Number(initialMax) - Number(initialMin))) *
        100;
      slider.style.setProperty('--range-progress', `${val}%`);
    });

    // Cleanup: remove event listeners
    return () => {
      sliders.forEach((slider) => {
        slider.removeEventListener('input', update);
      });
    };
  }, [props.value, props.min, props.max]);
  return (
    <input
      type={props.type}
      id={props.id}
      min={props.min}
      max={props.max}
      step={props.step}
      value={props.value}
      onChange={props.onChange}
      ref={ref}
      className={`${props.className} ltr`}
      style={props.style}
    />
  );
});
VideoVolumeBar.displayName = 'VideoVolumeBar';
export default VideoVolumeBar;
